import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import {sanitizeContent} from 'js/shared/security';
import { pushOpenDatesFilter, pushOpenDestinationFilter, pushOpenRoomsFilter } from 'js/scenes/MainSearchBox/customEvents'

import './brandingStatementWidget.scss'

const getHrefParam = (href, param) => {
  if (!href) return undefined
  try {
    const params = new URLSearchParams(href)
    return params.get(param)
  } catch (e) {
    return undefined
  }
}

const triggerLoginHandler = (e) => {
  const targetHref = e.target.getAttribute('href')
  const targetClassList = e.target.classList

  if (targetHref === '#log-in') {
    const loginLink = document.querySelector('.account-dropdown .log-in')
    if (loginLink) {
      e.preventDefault()
      loginLink.click()
    }
  }

  if (targetHref === '#change-my-date-btn') {
    e.preventDefault()
    pushOpenDatesFilter()
  }

  if (targetClassList.contains('extend-search')) {
    e.preventDefault()
    pushOpenDestinationFilter()
  }

  if (targetHref === '#change-my-acommodation-btn') {
    e.preventDefault()
    pushOpenRoomsFilter()
  }
}

const BrandingWidget = ({
  content = '',
  image = '',
  href = null,
  hotelsCount = '',
  isOffers = false,
}) => {
  const handleMainClick = (event) => {
    event.preventDefault()
    if (event.target.getAttribute('href') !== '#log-in') {
      const searchParams = window.location.search.replace('?', '&')
      window.location.href = `${href}${searchParams}`
    }
  }

  return (
    <div
      className={cn('branding-statement-widget', { isOffers })}
      geo_code={getHrefParam(href, 'geoCode')}
      geo_type={getHrefParam(href, 'geoType')}
    >
      <div className="branding-statement__holder">
        {href ? (
          <div
            onKeyDown={(e) => e.key === 'Enter' && handleMainClick(e)}
            onClick={handleMainClick}
            className="branding-statement"
            style={{ backgroundImage: `url(${image})` }}
          >
            <div className="branding-statement__logo" />
            <div
              onKeyDown={(e) => e.key === 'Enter' && triggerLoginHandler(e)}
              onClick={triggerLoginHandler}
              className="branding-statement__text wysiwyg-holder"
              dangerouslySetInnerHTML={{ __html: sanitizeContent(`${content} (${hotelsCount})`) }}
            />
          </div>
        ) : (
          <div
            className="branding-statement"
            style={{ backgroundImage: `url(${image})` }}
          >
            <div className="branding-statement__logo" />
            <div
              onKeyDown={(e) => e.key === 'Enter' && triggerLoginHandler(e)}
              onClick={triggerLoginHandler}
              className="branding-statement__text wysiwyg-holder"
              dangerouslySetInnerHTML={{ __html: sanitizeContent(content) }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

BrandingWidget.propTypes = {
  content: PropTypes.string,
  image: PropTypes.string,
  href: PropTypes.string,
  hotelsCount: PropTypes.string,
  isOffers: PropTypes.bool,
}

export default BrandingWidget
